var map = {
	"./": 72812,
	"./App": 32986,
	"./App.css": 44050,
	"./App.js": 32986,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./Assets/Background.png": 36584,
	"./Assets/chat-quote.png": 64773,
	"./Assets/closeIcon.png": 33113,
	"./Assets/left.png": 879,
	"./Assets/left_arrow.png": 15541,
	"./Assets/letterIcon.png": 17287,
	"./Assets/map1.jpg": 28719,
	"./Assets/map2.jpg": 38400,
	"./Assets/openLetterIcon.png": 27187,
	"./Assets/right.png": 8960,
	"./Assets/right_arrow.png": 99062,
	"./Assets/soundwave.png": 47448,
	"./Assets/x.png": 86026,
	"./Components/Home": 41878,
	"./Components/Home.jsx": 41878,
	"./Components/Section": 93334,
	"./Components/Section.jsx": 93334,
	"./Components/SideBar": 74615,
	"./Components/SideBar.jsx": 74615,
	"./Config": 77608,
	"./Config.jsx": 77608,
	"./Content/audio/Alksnis1.mp3": 31121,
	"./Content/audio/Alksnis2.mp3": 58686,
	"./Content/audio/Alksnis3.mp3": 43427,
	"./Content/audio/Berzs1.mp3": 69840,
	"./Content/audio/Berzs2-1.mp3": 1433,
	"./Content/audio/Berzs2-2.mp3": 67718,
	"./Content/audio/Berzs2-4.mp3": 32824,
	"./Content/audio/Berzs3-1.mp3": 61896,
	"./Content/audio/Berzs3-2.mp3": 97151,
	"./Content/audio/Berzs3-3.mp3": 4538,
	"./Content/audio/Eglitis1.mp3": 55243,
	"./Content/audio/Jasis1.mp3": 73424,
	"./Content/audio/Lapa1.mp3": 8492,
	"./Content/audio/Presnikovs1.mp3": 31806,
	"./Content/audio/Presnikovs2-1.mp3": 95339,
	"./Content/audio/Presnikovs2.mp3": 4241,
	"./Content/audio/Presnikovs3.mp3": 88908,
	"./Content/audio/Raiskums1.mp3": 36325,
	"./Content/audio/Ziemelis1.mp3": 4714,
	"./Content/audio/Ziemelis2-1.mp3": 33823,
	"./Content/audio/Ziemelis2.mp3": 65821,
	"./Content/audio/Ziemelis3.mp3": 53304,
	"./Content/audio/Ziemelis4-1.mp3": 63445,
	"./Content/audio/Ziemelis4.mp3": 27307,
	"./Content/images/10.jpg": 36358,
	"./Content/images/100.jpg": 98876,
	"./Content/images/101.jpg": 19929,
	"./Content/images/102.jpg": 12814,
	"./Content/images/103.jpg": 90859,
	"./Content/images/104.jpg": 67416,
	"./Content/images/105.jpg": 75285,
	"./Content/images/106.jpg": 49034,
	"./Content/images/107.jpg": 4871,
	"./Content/images/108-1.jpg": 62730,
	"./Content/images/108-2.jpg": 54805,
	"./Content/images/109.jpg": 20145,
	"./Content/images/11.jpg": 74883,
	"./Content/images/110.jpg": 91579,
	"./Content/images/111.jpg": 36798,
	"./Content/images/112.jpg": 10505,
	"./Content/images/113.jpg": 48780,
	"./Content/images/114.jpg": 3127,
	"./Content/images/115.jpg": 8666,
	"./Content/images/116.jpg": 31269,
	"./Content/images/12-1.jpg": 87242,
	"./Content/images/12.jpg": 80404,
	"./Content/images/13.jpg": 94129,
	"./Content/images/14.jpg": 4898,
	"./Content/images/15.jpg": 1215,
	"./Content/images/16.jpg": 33232,
	"./Content/images/17.jpg": 17805,
	"./Content/images/18.jpg": 19150,
	"./Content/images/19.jpg": 98635,
	"./Content/images/2.jpg": 19603,
	"./Content/images/20.jpg": 2187,
	"./Content/images/21.jpg": 75726,
	"./Content/images/22.jpg": 48217,
	"./Content/images/23.jpg": 34492,
	"./Content/images/24.jpg": 58279,
	"./Content/images/25.jpg": 35626,
	"./Content/images/26.jpg": 86613,
	"./Content/images/27.jpg": 95704,
	"./Content/images/28.jpg": 78435,
	"./Content/images/29.jpg": 97382,
	"./Content/images/3.jpg": 74838,
	"./Content/images/30.jpg": 77260,
	"./Content/images/31.jpg": 15305,
	"./Content/images/32/32-1.jpg": 21294,
	"./Content/images/32/32-2.jpg": 12057,
	"./Content/images/32/32-3.jpg": 7356,
	"./Content/images/32/32-4.jpg": 13351,
	"./Content/images/32/33-1.jpg": 28767,
	"./Content/images/32/33-2.jpg": 44432,
	"./Content/images/32/33-3.jpg": 45357,
	"./Content/images/32/33-4.jpg": 63910,
	"./Content/images/32/34-1.jpg": 25172,
	"./Content/images/32/34-2.jpg": 71235,
	"./Content/images/35/35-1.jpg": 69764,
	"./Content/images/35/35-2.jpg": 69811,
	"./Content/images/36/36-1.jpg": 97862,
	"./Content/images/36/36-2.jpg": 25617,
	"./Content/images/36/36-3.jpg": 11284,
	"./Content/images/36/36-4.jpg": 79071,
	"./Content/images/36/37-1.jpg": 87095,
	"./Content/images/36/37-2.jpg": 18696,
	"./Content/images/36/37-3.jpg": 45861,
	"./Content/images/36/37-4.jpg": 862,
	"./Content/images/36/38-1.jpg": 52052,
	"./Content/images/36/38-2.jpg": 81763,
	"./Content/images/36/38-3.jpg": 91654,
	"./Content/images/36/38-4.jpg": 7853,
	"./Content/images/39/39-1.jpg": 24996,
	"./Content/images/39/40-1.jpg": 30320,
	"./Content/images/39/40-2.jpg": 14047,
	"./Content/images/39/40-3.jpg": 5986,
	"./Content/images/39/40-4.jpg": 91217,
	"./Content/images/39/41-1.jpg": 41065,
	"./Content/images/39/41-2.jpg": 97982,
	"./Content/images/39/41-3.jpg": 45819,
	"./Content/images/39/41-4.jpg": 99464,
	"./Content/images/39/42-1.jpg": 678,
	"./Content/images/39/42-2.jpg": 28433,
	"./Content/images/39/42-3.jpg": 14100,
	"./Content/images/4.jpeg": 6274,
	"./Content/images/43.jpg": 26982,
	"./Content/images/44.jpg": 46061,
	"./Content/images/45.jpg": 93840,
	"./Content/images/46.jpg": 8191,
	"./Content/images/47.jpg": 130,
	"./Content/images/48.jpg": 54521,
	"./Content/images/49.jpg": 33468,
	"./Content/images/5.jpg": 29440,
	"./Content/images/50.jpg": 85370,
	"./Content/images/51.jpg": 56535,
	"./Content/images/52.jpg": 45608,
	"./Content/images/53.jpg": 73221,
	"./Content/images/54-1.jpg": 46524,
	"./Content/images/54-2.jpg": 14219,
	"./Content/images/55.jpg": 27195,
	"./Content/images/56.jpg": 50220,
	"./Content/images/57.jpg": 21833,
	"./Content/images/58.jpg": 34674,
	"./Content/images/59.jpg": 11055,
	"./Content/images/6.jpg": 19759,
	"./Content/images/60.jpg": 10879,
	"./Content/images/61.jpg": 14562,
	"./Content/images/63.jpg": 42896,
	"./Content/images/64.jpg": 84547,
	"./Content/images/65.jpg": 46022,
	"./Content/images/66.jpg": 3793,
	"./Content/images/67.jpg": 90068,
	"./Content/images/68.jpg": 37543,
	"./Content/images/69.jpg": 41738,
	"./Content/images/7.jpg": 43378,
	"./Content/images/70.jpg": 20704,
	"./Content/images/71.jpg": 59933,
	"./Content/images/72.jpg": 66386,
	"./Content/images/73.jpg": 34319,
	"./Content/images/74.jpg": 40004,
	"./Content/images/75.jpg": 18049,
	"./Content/images/76.jpg": 28470,
	"./Content/images/77.jpg": 91635,
	"./Content/images/78.jpg": 3496,
	"./Content/images/79.jpg": 65861,
	"./Content/images/8.jpg": 26089,
	"./Content/images/80-1.jpg": 49655,
	"./Content/images/80-2.jpg": 38728,
	"./Content/images/81.jpg": 1720,
	"./Content/images/82.jpg": 18215,
	"./Content/images/83.jpg": 22410,
	"./Content/images/84-1.jpg": 42387,
	"./Content/images/84-2.jpg": 42340,
	"./Content/images/84-3.jpg": 20385,
	"./Content/images/85.jpg": 63804,
	"./Content/images/86.jpg": 88971,
	"./Content/images/87.jpg": 9486,
	"./Content/images/88-1.jpg": 90847,
	"./Content/images/88-2.jpg": 92848,
	"./Content/images/88-3.jpg": 45069,
	"./Content/images/89-1.jpg": 30734,
	"./Content/images/89-2.jpg": 3225,
	"./Content/images/89-3.jpg": 89500,
	"./Content/images/9.jpg": 28300,
	"./Content/images/90.jpg": 35710,
	"./Content/images/91-1.jpg": 30229,
	"./Content/images/91-2.jpg": 3978,
	"./Content/images/92.jpg": 64044,
	"./Content/images/93-1.jpg": 12515,
	"./Content/images/93-2.jpg": 82804,
	"./Content/images/94.jpg": 23930,
	"./Content/images/95.jpg": 18391,
	"./Content/images/96.jpg": 84168,
	"./Content/images/97-1.jpg": 34503,
	"./Content/images/97-2.jpg": 54520,
	"./Content/images/97-3.jpg": 58837,
	"./Content/images/98.jpg": 9142,
	"./Content/images/99.jpg": 72307,
	"./Content/images/kart/100kart.jpeg": 76874,
	"./Content/images/kart/101kart.jpeg": 10221,
	"./Content/images/kart/102kart.jpeg": 16340,
	"./Content/images/kart/103kart.jpeg": 17895,
	"./Content/images/kart/104kart.jpeg": 46310,
	"./Content/images/kart/105kart.jpeg": 87817,
	"./Content/images/kart/106kart.jpeg": 61216,
	"./Content/images/kart/107kart.jpeg": 26835,
	"./Content/images/kart/108kart.jpeg": 78210,
	"./Content/images/kart/109kart.jpeg": 29509,
	"./Content/images/kart/10kart.jpeg": 1226,
	"./Content/images/kart/110kart.jpeg": 58071,
	"./Content/images/kart/111kart.jpeg": 92100,
	"./Content/images/kart/112kart.jpeg": 98109,
	"./Content/images/kart/113kart.jpeg": 12506,
	"./Content/images/kart/114kart.jpeg": 54531,
	"./Content/images/kart/115kart.jpeg": 84016,
	"./Content/images/kart/116kart.jpeg": 71033,
	"./Content/images/kart/117kart.jpeg": 47094,
	"./Content/images/kart/118kart.jpeg": 45743,
	"./Content/images/kart/119kart.jpeg": 22460,
	"./Content/images/kart/11kart.jpeg": 44589,
	"./Content/images/kart/120kart.jpeg": 1856,
	"./Content/images/kart/121kart.jpeg": 11795,
	"./Content/images/kart/122kart.jpeg": 89510,
	"./Content/images/kart/123kart.jpeg": 91497,
	"./Content/images/kart/124kart.jpeg": 6868,
	"./Content/images/kart/125kart.jpeg": 19815,
	"./Content/images/kart/126kart.jpeg": 17738,
	"./Content/images/kart/127kart.jpeg": 77453,
	"./Content/images/kart/128kart.jpeg": 10296,
	"./Content/images/kart/129kart.jpeg": 99659,
	"./Content/images/kart/12kart.jpeg": 74004,
	"./Content/images/kart/130kart.jpeg": 53829,
	"./Content/images/kart/131kart.jpeg": 18882,
	"./Content/images/kart/132kart.jpeg": 17983,
	"./Content/images/kart/133kart.jpeg": 14380,
	"./Content/images/kart/134kart.jpeg": 5281,
	"./Content/images/kart/135kart.jpeg": 9726,
	"./Content/images/kart/13kart.jpeg": 3303,
	"./Content/images/kart/14kart.jpeg": 56646,
	"./Content/images/kart/15kart.jpeg": 74985,
	"./Content/images/kart/16kart.jpeg": 68992,
	"./Content/images/kart/17kart.jpeg": 78931,
	"./Content/images/kart/18kart.jpeg": 83106,
	"./Content/images/kart/19kart.jpeg": 60805,
	"./Content/images/kart/1kart.jpeg": 50474,
	"./Content/images/kart/20kart.jpeg": 62533,
	"./Content/images/kart/21kart.jpeg": 11554,
	"./Content/images/kart/22kart.jpeg": 84479,
	"./Content/images/kart/23kart.jpeg": 6828,
	"./Content/images/kart/24kart.jpeg": 34497,
	"./Content/images/kart/25kart.jpeg": 56830,
	"./Content/images/kart/26kart.jpeg": 8939,
	"./Content/images/kart/27kart.jpeg": 77432,
	"./Content/images/kart/28kart.jpeg": 98317,
	"./Content/images/kart/29kart.jpeg": 88394,
	"./Content/images/kart/2kart.jpeg": 44839,
	"./Content/images/kart/30kart.jpeg": 16576,
	"./Content/images/kart/31kart.jpeg": 29171,
	"./Content/images/kart/32kart.jpeg": 99046,
	"./Content/images/kart/33kart.jpeg": 51049,
	"./Content/images/kart/34kart.jpeg": 10100,
	"./Content/images/kart/35kart.jpeg": 81447,
	"./Content/images/kart/36kart.jpeg": 87082,
	"./Content/images/kart/37kart.jpeg": 23757,
	"./Content/images/kart/38kart.jpeg": 20344,
	"./Content/images/kart/39kart.jpeg": 14379,
	"./Content/images/kart/3kart.jpeg": 73492,
	"./Content/images/kart/40kart.jpeg": 66251,
	"./Content/images/kart/41kart.jpeg": 12152,
	"./Content/images/kart/42kart.jpeg": 8033,
	"./Content/images/kart/43kart.jpeg": 61662,
	"./Content/images/kart/44kart.jpeg": 84319,
	"./Content/images/kart/45kart.jpeg": 50764,
	"./Content/images/kart/46kart.jpeg": 40645,
	"./Content/images/kart/47kart.jpeg": 89346,
	"./Content/images/kart/48kart.jpeg": 37971,
	"./Content/images/kart/49kart.jpeg": 72352,
	"./Content/images/kart/4kart.jpeg": 14441,
	"./Content/images/kart/50kart.jpeg": 94286,
	"./Content/images/kart/51kart.jpeg": 14257,
	"./Content/images/kart/52kart.jpeg": 90536,
	"./Content/images/kart/53kart.jpeg": 55611,
	"./Content/images/kart/54kart.jpeg": 41842,
	"./Content/images/kart/55kart.jpeg": 15285,
	"./Content/images/kart/56kart.jpeg": 85084,
	"./Content/images/kart/57kart.jpeg": 25871,
	"./Content/images/kart/58kart.jpeg": 56150,
	"./Content/images/kart/59kart.jpeg": 46361,
	"./Content/images/kart/5kart.jpeg": 62438,
	"./Content/images/kart/60kart.jpeg": 2633,
	"./Content/images/kart/61kart.jpeg": 646,
	"./Content/images/kart/62kart.jpeg": 22931,
	"./Content/images/kart/63kart.jpeg": 12992,
	"./Content/images/kart/64kart.jpeg": 88589,
	"./Content/images/kart/65kart.jpeg": 28874,
	"./Content/images/kart/66kart.jpeg": 30951,
	"./Content/images/kart/67kart.jpeg": 18004,
	"./Content/images/kart/68kart.jpeg": 97121,
	"./Content/images/kart/69kart.jpeg": 31998,
	"./Content/images/kart/6kart.jpeg": 92563,
	"./Content/images/kart/70kart.jpeg": 3236,
	"./Content/images/kart/71kart.jpeg": 69207,
	"./Content/images/kart/72kart.jpeg": 23642,
	"./Content/images/kart/73kart.jpeg": 9245,
	"./Content/images/kart/74kart.jpeg": 95152,
	"./Content/images/kart/75kart.jpeg": 65667,
	"./Content/images/kart/76kart.jpeg": 19497,
	"./Content/images/kart/77kart.jpeg": 82169,
	"./Content/images/kart/78kart.jpeg": 33596,
	"./Content/images/kart/79kart.jpeg": 56879,
	"./Content/images/kart/7kart.jpeg": 79968,
	"./Content/images/kart/80kart.jpeg": 98431,
	"./Content/images/kart/81kart.jpeg": 524,
	"./Content/images/kart/82kart.jpeg": 16805,
	"./Content/images/kart/83kart.jpeg": 39106,
	"./Content/images/kart/84kart.jpeg": 39147,
	"./Content/images/kart/85kart.jpeg": 49784,
	"./Content/images/kart/86kart.jpeg": 25473,
	"./Content/images/kart/87kart.jpeg": 60350,
	"./Content/images/kart/88kart.jpeg": 59303,
	"./Content/images/kart/89kart.jpeg": 46356,
	"./Content/images/kart/8kart.jpeg": 95653,
	"./Content/images/kart/90kart.jpeg": 7474,
	"./Content/images/kart/91kart.jpeg": 2069,
	"./Content/images/kart/92kart.jpeg": 61948,
	"./Content/images/kart/93kart.jpeg": 85231,
	"./Content/images/kart/94kart.jpeg": 31726,
	"./Content/images/kart/95kart.jpeg": 19569,
	"./Content/images/kart/96kart.jpeg": 25576,
	"./Content/images/kart/97kart.jpeg": 96475,
	"./Content/images/kart/98kart.jpeg": 51994,
	"./Content/images/kart/99kart.jpeg": 37597,
	"./Content/images/kart/9kart.jpeg": 44354,
	"./Content/images/logo.png": 42996,
	"./Content/maps/1.jpg": 103,
	"./Content/maps/2.jpg": 46296,
	"./Content/maps/3.jpg": 54165,
	"./Content/tables/4-3.jpg": 21560,
	"./Content/tables/4-4.jpg": 25163,
	"./Content/tables/4-45.jpg": 79538,
	"./Content/tables/4-46.jpg": 98493,
	"./Content/tables/4-5.jpg": 45678,
	"./Content/tables/4-6.jpg": 44345,
	"./Content/tables/4-7.jpg": 99996,
	"./Content/tables/4-8.jpg": 27743,
	"./Content/video/video.mp4": 4168,
	"./Design/BlurredButton": 40986,
	"./Design/BlurredButton.jsx": 40986,
	"./Design/Colors": 78181,
	"./Design/Colors.jsx": 78181,
	"./Design/Creators": 3538,
	"./Design/Creators.jsx": 3538,
	"./Design/DocumentGallery": 5394,
	"./Design/DocumentGallery.jsx": 5394,
	"./Design/ExhibitionContainer": 39321,
	"./Design/ExhibitionContainer.jsx": 39321,
	"./Design/Fonts/RedHatText-Bold.ttf": 45631,
	"./Design/Fonts/RedHatText-Italic.ttf": 39334,
	"./Design/Fonts/RedHatText-Light.ttf": 44374,
	"./Design/Fonts/RedHatText-Medium.ttf": 50371,
	"./Design/Fonts/RedHatText-Regular.ttf": 54726,
	"./Design/Fonts/RedHatText-SemiBold.ttf": 56069,
	"./Design/FullScreenGallery": 68154,
	"./Design/FullScreenGallery.jsx": 68154,
	"./Design/FullScreenTextGallery": 93029,
	"./Design/FullScreenTextGallery.jsx": 93029,
	"./Design/Gallery": 62407,
	"./Design/Gallery.jsx": 62407,
	"./Design/Letters/Letters": 86952,
	"./Design/Letters/Letters.jsx": 86952,
	"./Design/Letters/LettersAudioPlayer": 21340,
	"./Design/Letters/LettersAudioPlayer.jsx": 21340,
	"./Design/Letters/LettersGallery": 96860,
	"./Design/Letters/LettersGallery.jsx": 96860,
	"./Design/Letters/audioPlayer.css": 31191,
	"./Design/LinkGallery": 48183,
	"./Design/LinkGallery.jsx": 48183,
	"./Design/LinkedTitle": 19334,
	"./Design/LinkedTitle.jsx": 19334,
	"./Design/Quote": 17613,
	"./Design/Quote.jsx": 17613,
	"./Design/Text": 8664,
	"./Design/Text.jsx": 8664,
	"./Design/TextGallery": 37036,
	"./Design/TextGallery.jsx": 37036,
	"./Design/Title": 35231,
	"./Design/Title.jsx": 35231,
	"./Design/Utilities": 50485,
	"./Design/Utilities.jsx": 50485,
	"./Design/useWindowSize": 98883,
	"./Design/useWindowSize.jsx": 98883,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;